import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { appData } from 'Settings';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ExploreCards from 'Components/ExploreCards';
import SectionGroup from 'Components/SectionGroup';
import TextBlock from 'Components/TextBlock';
import ModelCard from 'Containers/ModelCard';
import ExplorePageBanners from 'Containers/ExplorePageBanners';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import { hasSpecialAccess } from 'Utils/specialAccess';
import {
  fetchSchoolDisabledModules,
  postSchoolDisabledModules,
} from 'Store/schools/actions';
import Tooltip from 'Components/Tooltip';
import {
  getActiveUser,
  getActiveSchoolId,
  getActiveSchool,
  getLicensesForSchool,
} from 'Store/reducers';
import { getLicenseType } from 'Settings/pricing-options';
import EditEnabledModulesLightbox from 'Components/EditEnabledModulesForm/EditEnabledModulesLightbox';

const propTypes = {
  location: PropTypes.object.isRequired,
  activeUser: PropTypes.object.isRequired,
  activeSchool: PropTypes.object.isRequired,
  schoolLicenses: PropTypes.array,
  hideModal: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  isModalActive: PropTypes.bool.isRequired,
  schoolId: PropTypes.number.isRequired,
  postSchoolDisabledModules: PropTypes.func.isRequired,
  fetchSchoolDisabledModules: PropTypes.func.isRequired,
};

class ExploreModelsPage extends React.PureComponent {
  componentDidMount() {
    const { schoolId, activeUser } = this.props;
    console.log(activeUser);
    if (schoolId) {
      this.props.fetchSchoolDisabledModules(schoolId, activeUser.id);
    }
  }

  render() {
    const {
      location,
      activeUser,
      activeSchool,
      schoolId,
      postSchoolDisabledModules,
      schoolLicenses,
    } = this.props;

    const { disabledModules, classDisabledModules } = activeSchool || {};

    if (
      !hasSpecialAccess(location) &&
      (!activeUser || !disabledModules || !classDisabledModules)
    ) {
      return <Loading />;
    }

    const { isEducator, isAdmin } = activeUser || {};
    const licenseType =
      getLicenseType[schoolLicenses && schoolLicenses[0].license_type];

    const isSchoolLicense = licenseType === 'school';

    const disabledModulesToUse =
      licenseType && !isSchoolLicense ? disabledModules : classDisabledModules;

    const showEditEnabledModulesButton =
      isAdmin && licenseType && !isSchoolLicense;

    // const showEditEnabledModulesButton = true;

    const disabledModulesList = appData.filter(({ slug }) =>
      (disabledModulesToUse || []).includes(slug)
    );
    const enabledModulesList = appData.filter(
      ({ slug }) => !(disabledModulesToUse || []).includes(slug)
    );

    return (
      <main className="Page__content">
        {activeUser && <ExplorePageBanners />}

        <ExploreCards
          type="model"
          tooltip={
            showEditEnabledModulesButton && (
              <div
                style={{
                  flexGrow: 1,
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <EditEnabledModulesLightbox
                  disabledModules={disabledModules}
                  onSubmit={(disabledModules) => {
                    postSchoolDisabledModules(schoolId, disabledModules);
                  }}
                />
              </div>
            )
          }
          items={(isEducator && isSchoolLicense
            ? appData
            : enabledModulesList
          ).map((item) => {
            const { published, slug } = item;
            return (
              published && <ModelCard {...item} key={`ModelCard-${slug}`} />
            );
          })}
        />

        {/* Disabled modules */}
        {!isSchoolLicense && isEducator && disabledModulesList.length > 0 && (
          <ExploreCards
            type="model_inactive"
            tooltip={
              <Tooltip
                body={
                  <ConnectedFormattedMessage id="explore_models.inactive_modules.tooltip" />
                }
              />
            }
            items={disabledModulesList.map((item) => {
              const { published, slug } = item;
              return (
                published && (
                  <ModelCard isDisabled {...item} key={`ModelCard-${slug}`} />
                )
              );
            })}
          />
        )}

        {isEducator && (
          <SectionGroup additionalClasses=" SectionGroup--educator-info">
            <div className="SectionGroup__column">
              <TextBlock
                type="large"
                headline={
                  <ConnectedFormattedMessage id="explore_models.educator_info.welcome.title" />
                }
                headlineIcon="LogoMark-TinybopSchools.png"
                description={
                  <p className="TextBlock__paragraph">
                    <ConnectedFormattedMessage id="explore_models.educator_info.welcome.description" />
                  </p>
                }
              />
            </div>
            <div className="SectionGroup__column">
              <TextBlock
                type="large"
                headline={
                  <ConnectedFormattedMessage id="explore_models.educator_info.introduce_stem.title" />
                }
                backgroundIcon="TeachingWithTinybop.png"
                description={
                  <p className="TextBlock__paragraph">
                    <ConnectedFormattedMessage id="explore_models.educator_info.introduce_stem.description" />
                  </p>
                }
              />
            </div>
          </SectionGroup>
        )}
      </main>
    );
  }
}

ExploreModelsPage.propTypes = propTypes;

const mapStateToProps = (state) => {
  const activeSchool = getActiveSchool(state);
  return {
    activeUser: getActiveUser(state),
    schoolId: getActiveSchoolId(state),
    activeSchool,
    schoolLicenses: activeSchool
      ? getLicensesForSchool(state, activeSchool.id)
      : null,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    fetchSchoolDisabledModules,
    postSchoolDisabledModules,
  })(ExploreModelsPage)
);
